module.exports = __webpack_public_path__ + "static/media/C_F02.9125020d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_F02.png
// module id = 125
// module chunks = 0